<template>
  <div class="md:pb-0 lg:pb-0 relative">
    <b-modal id="modal-1" title="Share" centered hide-footer>
      <div class="d-flex justify-content-around mb-8">
        <a
          rel="nofollow"
          :href="`https://facebook.com/share.php?u=${copy}`"
          target="_black"
        >
          <img
            class="w-10 h-10 cursor-pointer"
            src="@/assets/icons/facebook.svg"
            alt=""
          />
        </a>
        <a
          :href="`https://linkedin.com/sharing/share-offsite/?url=${copy}`"
          target="_black"
        >
          <img
            class="w-10 h-10 cursor-pointer"
            src="@/assets/icons/Linkedin.svg"
          />
        </a>
        <a :href="`mailto:?body=${copy}`" target="_black">
          <img
            class="w-10 h-10 cursor-pointer"
            src="@/assets/icons/Mail.svg"
            alt=""
          />
        </a>
        <a :href="`https://api.whatsapp.com/send?text=${copy}`" target="_black">
          <img
            class="w-10 h-10 cursor-pointer"
            src="@/assets/icons/Whatsapp.svg"
            alt=""
          />
        </a>
        <a
          :href="`https://twitter.com/share?text=google&url=${copy}`"
          target="_black"
        >
          <img
            class="w-10 h-10 cursor-pointer"
            src="@/assets/icons/Twitter.svg"
            alt=""
          />
        </a>
      </div>

      <!-- <div class="container" ref="modalBody">
        <input type="text" v-model="message" />
        <button type="button" @click="doCopy(message)">Copy!</button>
      </div> -->
      <b-input-group size="md" class="mb-2">
        <b-form-input
          type="text"
          :class="{ inputstyle: applystyle }"
          v-model="copy"
        ></b-form-input>
        <b-input-group-prepend
          ref="modalBody"
          type="button"
          is-text
          class="cursor-pointer textstyle"
          @click="doCopy(copy)"
        >
          COPY
        </b-input-group-prepend>
      </b-input-group>
    </b-modal>
    <!-- <div
      class="absolute insights-bg md:block lg:block hidden md-hidden z-index--1"
    >
      <img
        src="../../../../assets/images/line/insig-line.svg"
        alt="bg-polygon"
        class="h-full w-full"
      />
    </div> -->
    <img
      src="@/assets/images/line/Vector 7.png"
      alt="lineimg"
      class="m-auto px-4"
    />
    <!-- <div class="absolute insights-bg-mob md:hidden lg:hidden block z-index--1">
      <img
        src="../../../../assets/images/line/inst-news-bg-mob.svg"
        alt="bg-polygon"
        class="h-full w-full"
      />
    </div> -->
    <div>
      <div
        class="md:w-4/5 lg:w-4/5 w-full md:px-0 lg:px-0 px-4 mx-auto md:pt-0 lg:pt-0"
      >
        <!-- <div class="lg:flex md:flex justify-between items-center">
          <p class="title fsize36-16px-isg z-index--1">Featured Events</p>
          <p class="title fsize36-16px-isg z-index--1">Events</p>
          <div class="lg:mt-0 md:mt-0 mt-4">
            <div class="flex text-black">
              <b-form-select
                v-model="selectedTopic"
                class="mr-4 border-2 border-primary lg:text-base md:text-base text-xs text-primary font-medium"
                ><b-form-select-option :value="null" disabled
                  >{{ filters.length ? filters[0].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag1 in filter1"
                  :value="filtertag1._id"
                  :key="filtertag1._id"
                  >{{ filtertag1.name }}</b-form-select-option
                ></b-form-select
              >
              <b-form-select
                v-model="selectedCategories"
                class="mr-4 border-2 border-primary lg:text-base md:text-base text-xs text-primary font-medium"
                ><b-form-select-option :value="null" disabled
                  >{{ filters.length ? filters[1].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag2 in filter2"
                  :value="filtertag2._id"
                  :key="filtertag2._id"
                  >{{ filtertag2.name }}</b-form-select-option
                ></b-form-select
              >
              <b-form-select
                v-model="selectedUsers"
                class="border-2 border-primary lg:text-base md:text-base text-xs text-primary font-medium"
              >
                <b-form-select-option :value="null" disabled
                  >{{ filters.length ? filters[2].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag3 in filter3"
                  :value="filtertag3._id"
                  :key="filtertag3._id"
                  >{{ filtertag3.name }}</b-form-select-option
                >
              </b-form-select>
            </div>
          </div>
        </div> -->
        <!-- <p
          class="text-end text-primary cursor-pointer fsize14 font-semibold hov-underline sm-fsize12"
          @click="handleClear"
        >
          Clear Filter
        </p>  -->
        <div v-if="featuredEvent.length !== 0" class="lg:mb-16 md:mb-12 mb-4">
          <div class="lg:flex md:flex justify-between items-center">
            <p class="title fsize36-16px-isg">Featured Events</p>
            <!-- <p class="title fsize36-16px-isg z-index--1">Featured Events</p> -->
          </div>
          <div class="md:pt-4 lg:pt-4 pt-0">
            <!-- <div class="text-center text-2xl" v-if="featuredEvent.length === 0">
            No Featured Events
          </div> -->
            <div class="grid md:grid-cols-3 lg:grid-cols-3 grid-cols-1 gap-8">
              <EventCArd
                v-for="item in displayedPagesForFeatured"
                :key="item._id"
                :item="item"
                type="Featured Events"
                :category="item.pageCategory.name"
                :data="displayedPagesForFeatured"
              />
            </div>
          </div>
          <div class="flex mt-4 flex-wrap" v-if="featuredEvent.length !== 0">
            <b-pagination
              v-model="featuredCurrentPage"
              :total-rows="featuredEvent.length"
              :per-page="featuredPerPage"
              size="lg"
            ></b-pagination>
            <!-- <b-pagination
            @change="
              (value) => {
                currentPage = value;
              }
            "
            pills
            :total-rows="total_row"
            :per-page="perPage"
            size="lg"
            class="ml-auto flex flex-wrap"
          ></b-pagination> -->
          </div>
        </div>
        <div
          v-if="upcomingEvent.length !== 0"
          aria-activedescendant=""
          class="lg:mb-16 md:mb-12 mb-4"
        >
          <div class="lg:flex md:flex justify-between items-center">
            <p class="title fsize36-16px-isg">Upcoming Events</p>
            <div class="lg:mt-0 md:mt-0 mt-4">
              <!-- <div class="flex text-black">
              <b-form-select
                v-model="selectedTopic"
                class="mr-4 border-2 border-primary lg:text-base md:text-base text-xs text-primary font-medium"
                ><b-form-select-option :value="null" disabled
                  >{{ filters.length ? filters[0].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag1 in filter1"
                  :value="filtertag1._id"
                  :key="filtertag1._id"
                  >{{ filtertag1.name }}</b-form-select-option
                ></b-form-select
              >
              <b-form-select
                v-model="selectedCategories"
                class="mr-4 border-2 border-primary lg:text-base md:text-base text-xs text-primary font-medium"
                ><b-form-select-option :value="null" disabled
                  >{{ filters.length ? filters[1].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag2 in filter2"
                  :value="filtertag2._id"
                  :key="filtertag2._id"
                  >{{ filtertag2.name }}</b-form-select-option
                ></b-form-select
              >
              <b-form-select
                v-model="selectedUsers"
                class="border-2 border-primary lg:text-base md:text-base text-xs text-primary font-medium"
              >
                <b-form-select-option :value="null" disabled
                  >{{ filters.length ? filters[2].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag3 in filter3"
                  :value="filtertag3._id"
                  :key="filtertag3._id"
                  >{{ filtertag3.name }}</b-form-select-option
                >
              </b-form-select>
            </div> -->
            </div>
          </div>
          <div class="md:pt-4 lg:pt-8 pt-0">
            <!-- <div class="text-center text-2xl" v-if="upcomingEvent.length === 0">
            No Upcoming Events
          </div> -->
            <div class="grid md:grid-cols-3 lg:grid-cols-3 grid-cols-1 gap-8">
              <div
                v-for="(item, index) in upcomingEvent"
                :key="`${item}+${index}`"
              >
                <EventCard
                  :key="item._id"
                  :item="item"
                  :data="upcomingEvent"
                  type="Upcoming"
                  class=""
                  @eventCopy="eventCopy"
                >
                </EventCard>
                <!-- <div class="shareButton">
                  <img
                    v-b-modal.modal-1
                    @click="
                      dialogVisible = true;
                      setLink(item.link);
                    "
                    :key="item._id"
                    src="./../../../../assets/images/share.png"
                    alt="ShareIcon"
                    class="h-6 w-6 cursor-pointer"
                  />
                </div> -->
              </div>
              <!-- <EventCArd
                v-for="item in displayedPagesForUpcoming"
                :key="item._id"
                :item="item"
                :category="item.pageCategory.name"
                :data="displayedPagesForUpcoming"
              >
              </EventCArd>
              <img
                v-b-modal.modal-1
                @click="dialogVisible = true"
                src="./../../../../assets/images/share.png"
                alt="ShareIcon"
                class="h-6 w-6 cursor-pointer"
              /> -->
            </div>
          </div>
          <div class="flex mt-4 flex-wrap" v-if="upcomingEvent.length !== 0">
            <b-pagination
              v-model="currentPage"
              @change="
                (value) => {
                  currentPage = value;
                  init();
                }
              "
              :total-rows="pageCount"
              :per-page="10"
              size="lg"
            ></b-pagination>
            <!-- <b-pagination
            @change="handlePageChange"
            v-model="currentPage"
            :total-rows="rows"
            size="lg"
          ></b-pagination> -->
            <!-- <b-pagination
            @change="
              (value) => {
                currentPage = value;
              }
            "
            pills
            :total-rows="total_row"
            :per-page="perPage"
            size="lg"
            class="ml-auto flex flex-wrap"
          ></b-pagination> -->
          </div>
        </div>
        <div id="topSection"></div>
        <div v-if="pastEvent.length !== 0" class="lg:mb-16 md:mb-12 mb-4">
          <div class="lg:flex md:flex justify-between items-center">
            <p class="title fsize36-16px-isg">Past Events</p>
            <div class="lg:mt-0 md:mt-0 mt-4"></div>
          </div>
          <div class="md:pt-4 lg:pt-8 pt-0">
            <!-- <div class="text-center text-2xl" v-if="pastEvent.length === 0">
            No Past Events
          </div> -->
            <div class="grid md:grid-cols-3 lg:grid-cols-3 grid-cols-1 gap-8">
              <EventCArd
                v-for="item in displayedPagesForPast"
                :key="item._id"
                :item="item"
                type="Past Events"
                :category="item.pageCategory.name"
                :data="displayedPagesForPast"
              />
            </div>
          </div>
          <div class="flex mt-4 flex-wrap" v-if="pastEvent.length !== 0">
            <b-pagination
              v-model="pastCurrentPage"
              :total-rows="pastEvent.length"
              :per-page="pastPerPage"
              size="lg"
            ></b-pagination>
            <!-- <b-pagination
            @change="
              (value) => {
                currentPage = value;
              }
            "
            pills
            :total-rows="total_row"
            :per-page="perPage"
            size="lg"
            class="ml-auto flex flex-wrap"
          ></b-pagination> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EventCArd from "./EventCard.vue";
import { mapState } from "vuex";
import _ from "lodash";
import EventCard from "./EventCard.vue";
export default {
  components: {
    EventCArd,
    EventCard,
  },
  data() {
    return {
      filter1: [],
      filter2: [],
      filter3: [],
      filteredData: [],
      copy: "",
      categoryId: null,
      selectedTopic: null,
      selectedUsers: null,
      selectedCategories: null,
      rows: Number,
      tagid: [],
      featuredEvent: [],
      upcomingEvent: [],
      pastEvent: [],
      featuredCurrentPage: 1,
      featuredPerPage: 8,
      upcomingCurrentPage: 1,
      upcomingPerPage: 8,
      pastCurrentPage: 1,
      pastPerPage: 8,
      applystyle: false,
    };
  },
  watch: {
    async selectedTopic(val) {
      if (this.tagid.length > 3) {
        this.tagid = [];
      }
      this.tagid.unshift(val);
      if (val) {
        let payload = {
          offset:
            this.currentPage > 1
              ? (this.currentPage - 1) * 10
              : this.currentPage,
          id: this.categoryId,
          tagid: this.tagid,
        };
        // this.filteredData = this.$store.dispatch(
        //   "cms/getpagebycategory",
        //   payload
        // );

        const data = await this.$store.dispatch(
          "cms/GetPagesbyCategoryForEvent",
          payload
        );

        if (data.code === 200) {
          this.featuredEvent = this.categorywisepagesforevent.featured;
          this.upcomingEvent = this.categorywisepagesforevent.upcoming;
          this.pastEvent = this.categorywisepagesforevent.past;
        }

        this.loadData();
      }
    },
    async selectedCategories(val) {
      if (this.tagid.length > 3) {
        this.tagid = [];
      }
      this.tagid.unshift(val);

      if (val) {
        let payload = {
          offset:
            this.currentPage > 1
              ? (this.currentPage - 1) * 10
              : this.currentPage,
          id: this.categoryId,
          tagid: this.tagid,
        };
        // console.log(payload);
        // this.filteredData = this.$store.dispatch(
        //   "cms/getpagebycategory",
        //   payload
        // );

        const data = await this.$store.dispatch(
          "cms/GetPagesbyCategoryForEvent",
          payload
        );

        if (data.code === 200) {
          this.featuredEvent = this.categorywisepagesforevent.featured;
          this.upcomingEvent = this.categorywisepagesforevent.upcoming;
          this.pastEvent = this.categorywisepagesforevent.past;
        }

        this.loadData();
      }
    },
    async selectedUsers(val) {
      if (this.tagid.length > 3) {
        this.tagid = [];
      }
      this.tagid.unshift(val);

      if (val) {
        let payload = {
          offset:
            this.currentPage > 1
              ? (this.currentPage - 1) * 10
              : this.currentPage,
          id: this.categoryId,
          tagid: this.tagid,
        };

        // this.filteredData = this.$store.dispatch(
        //   "cms/getpagebycategory",
        //   payload
        // );
        const data = await this.$store.dispatch(
          "cms/GetPagesbyCategoryForEvent",
          payload
        );

        if (data.code === 200) {
          this.featuredEvent = this.categorywisepagesforevent.featured;
          this.upcomingEvent = this.categorywisepagesforevent.upcoming;
          this.pastEvent = this.categorywisepagesforevent.past;
        }

        this.loadData();
      }
    },
    categorywisepages(val) {
      if (this.tagid.length > 0) {
        this.categorywisepages = { ...categorywisepages };
      }
    },
  },
  computed: {
    ...mapState("auth", { user: "user", getUserByUserId: "getUserByUserId" }),
    ...mapState("cms", {
      pageCategories: "pageCategories",
      filtertags: "filtertags",
      filters: "filters",
      categorywisepagesforevent: "categorywisepagesforevent",
      pages: "pages",
      categorywisepages: "categorywisepages",
    }),

    displayedPagesForFeatured() {
      return this.featuredEvent.slice(
        (this.featuredCurrentPage - 1) * this.featuredPerPage,
        this.featuredCurrentPage * this.featuredPerPage
      );
    },
    upcomingEvent() {
      return this.upcomingEvent.slice(
        (this.currentPage - 1) * this.upcomingPerPage,
        this.currentPage * this.upcomingPerPage
      );
    },

    displayedPagesForUpcoming() {
      return this.upcomingEvent.slice(
        (this.upcomingCurrentPage - 1) * this.upcomingPerPage,
        this.upcomingCurrentPage * this.upcomingPerPage
      );
    },

    displayedPagesForPast() {
      return this.pastEvent.slice(
        (this.pastCurrentPage - 1) * this.pastPerPage,
        this.pastCurrentPage * this.pastPerPage
      );
    },

    // displayedPages() {
    //   return this.pages.slice(
    //     (this.currentPage - 1) * this.perPage,
    //     this.currentPage * this.perPage
    //   );
    // },
    // total_row() {
    //   return this.pages.length;
    // },
  },

  methods: {
    async handlePageChange(value) {
      this.currentPage = value;
      let payload = {
        offset:
          this.currentPage > 1 ? (this.currentPage - 1) * 10 : this.currentPage,
        id: this.categoryId,
        // tagid: this.tagid,
      };
      this.filteredData = await this.$store.dispatch(
        "cms/getpagebycategory",
        payload
      );
    },
    handleClick(name) {
      this.$router.push({ name: name });
      this.toggleNavbar();
    },
    handleClear() {
      this.selectedTopic = null;
      this.selectedUsers = null;
      this.selectedCategories = null;
      this.tagid = [];
      this.init();
    },

    setLink(link) {
      this.copy = link;
      // console.log(link);
    },
    eventCopy(link) {
      // console.log(link);
      this.copy = link;
    },

    doCopy(copy) {
      this.$copyText(copy, this.$refs.modalBody);
      this.applystyle = true;
      // swal.fire({ title: "", icons: "success" });
      this.$swal.fire({
        text: "Link copied to clipboard",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
        timer: 2000,
      });
    },
    async loadData() {
      let loader = this.$loading();
      try {
        let categoryUsers = [],
          categoryTopics = [],
          category = [];
        if (this.selectedUsers != null)
          categoryUsers = this.categorywisepages.filter((x) => {
            return x.tags.includes(this.selectedUsers);
          });
        if (this.selectedCategories != null)
          category = this.categorywisepages.filter((x) => {
            return x.tags.includes(this.selectedCategories);
          });
        if (this.selectedTopic != null)
          categoryTopics = this.categorywisepages.filter((x) => {
            return x.tags.includes(this.selectedTopic);
          });

        let combinedFilter = [...categoryUsers, ...category, ...categoryTopics];
        this.filteredData = _.uniq(combinedFilter);

        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async init() {
      // await this.$store.dispatch("cms/getPageCategories");
      // this.pageCategories.forEach((element) => {
      //   if (element.route.includes("events")) this.categoryId = element._id;
      // });
      // await this.$store.dispatch("cms/getTagsbyCategory", {
      //   categoryPage: this.categoryId,
      // });
      // await this.$store.dispatch("cms/getfilterbycategory", {
      //   categoryPage: this.categoryId,
      // });
      // this.filter1 = this.filtertags.filter(
      //   (x) => x.filter._id == this.filters[0]._id
      // );
      // this.filter2 = this.filtertags.filter(
      //   (x) => x.filter._id == this.filters[1]._id
      // );
      // this.filter3 = this.filtertags.filter(
      //   (x) => x.filter._id == this.filters[2]._id
      // );
      // let filteredAPIData = await this.$store.dispatch(
      //   "cms/getpagebycategory",
      //   {
      //     id: this.categoryId,
      //   }
      // );
      // this.filteredData = filteredAPIData.data;
      // this.rows = Number(this.filteredData.totalPages);
      // const data = await this.$store.dispatch(
      //   "cms/GetPagesbyCategoryForEvent",
      //   {
      //     id: this.categoryId,
      //   }
      // );
      // if (data.code === 200) {
      //   this.featuredEvent = this.categorywisepagesforevent.featured;
      //   this.upcomingEvent = this.categorywisepagesforevent.upcoming;
      //   this.pastEvent = this.categorywisepagesforevent.past;
      // }
    },
  },
  async mounted() {
    this.init();
    if (Object.keys(this.user).length !== 0) {
      let getUserPayload = {
        userId: this.user._id,
      };
      const getUser = await this.$store.dispatch(
        "auth/getUserByUserId",
        getUserPayload
      );
    }
  },
};
</script>
<style>
.wrapper {
  position: relative;
}
.shareButton {
  position: absolute;
  top: 35%;
  right: 74%;
}
</style>
